import axios from 'axios';
import { API_CONFIG } from '../config/api.js';

class ApiService {
  static async getVersion() {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/version`);
      const data = response.data;
      return {
        hf_arch: data.model_info?.hf_architecture || 'Unknown',
        labels: data.model_info?.label_set || [],
      };
    } catch (error) {
      console.error('Failed to fetch version:', error);
      throw error;
    }
  }

  static async predict(text) {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/predict/fallback`,
        { data: { text: text.trim(), topk: 3 } },
        {
          timeout: API_CONFIG.TIMEOUT,
          withCredentials: true
        }
      );
      return response.data;
    } catch (error) {
      console.error('Prediction failed:', error);
      throw error;
    }
  }

  static async healthCheck() {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/health`);
      return response.data;
    } catch (error) {
      console.error('Health check failed:', error);
      throw error;
    }
  }
}

export default ApiService;